
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l/neueintragungen",
      function () {
        return require("private-next-pages/l/neueintragungen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l/neueintragungen"])
      });
    }
  